export default {
  document: {
    '@dark': { background: 'neutral950', color: 'neutral50' },
    '@light': { background: 'neutral50', color: 'neutral900' },
  },
  primary: {
    '@dark': { background: 'green', color: 'neutral950' },
    '@light': { background: 'green', color: 'neutral950' },
    fontWeight: '600',
  },
  secondary: {
    '@dark': { background: 'neutral800', color: 'neutral50' },
    '@light': { background: 'neutral100', color: 'neutral900' },
  },
  ghost: {
    '@dark': { background: 'transparent', color: 'neutral300', border: '1px solid neutral700' },
    '@light': { background: 'transparent', color: 'neutral600', border: '1px solid neutral200' },
  },
  ghostTeal: {
    '@dark': { background: 'transparent', color: 'green', border: '1px solid greenBorder' },
    '@light': { background: 'transparent', color: 'green', border: '1px solid greenBorder' },
  },
  card: {
    '@dark': { background: 'neutral800', color: 'neutral50', border: '1px solid neutral700' },
    '@light': { background: 'white', color: 'neutral900', border: '1px solid neutral200' },
  },
  sidebar: {
    '@dark': { background: 'neutral950', color: 'neutral50' },
    '@light': { background: 'white', color: 'neutral900' },
  },
  none: { '@dark': { color: 'none', background: 'none' }, '@light': { color: 'none', background: 'none' } },
  transparent: { '@dark': { color: 'currentColor', background: 'transparent', border: 'none' }, '@light': { color: 'currentColor', background: 'transparent', border: 'none' } },
  danger: { background: 'redBg', color: 'red', border: '1px solid redBorder' },
  warning: { background: 'amberBg', color: 'amber', border: '1px solid amberBorder' },
  success: { background: 'greenBg', color: 'green', border: '1px solid greenBorder' },
}
